import { map } from 'rxjs/operators';
import { ITransaction } from './../monitor/ITransaction';
// import { Observable } from 'rxjs';
// import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as myGlobals from './../global';
import { Merchant } from '../shared/merchant.model';
import { HttpClientSecured } from '../services/http-client-secured';
// import { ReportFilter } from './report.filter.model';
import { MonitorFilter } from './monitor.filter.model';

@Injectable({
  providedIn: 'root'
})
export class MonitorService {
  private monitorUrl = myGlobals.baseApi + '/merchantsWithComposedName';
  private lastTransactionsUrl = myGlobals.baseApi + '/financial/last-transactions';

  constructor(private http: HttpClientSecured) {}

  getLastTransactions(merchantId: number, status: string, accountingNature: string) {
    console.log('MonitorService: getLastTransactions: merchantId:** ', merchantId);
    if (merchantId === null) {
      merchantId = 0;
    }

    if (status != null && status === '') {
      status = '0';
    }

    if (accountingNature != null && accountingNature === '') {
      accountingNature = '0';
    }

    const monitorFilter = new MonitorFilter();
    monitorFilter.merchantId = merchantId;
    monitorFilter.status = status;
    monitorFilter.accountingNature = accountingNature;
    console.log('MonitorService: getLastTransactions: merchantId: ', merchantId);
    console.log('MonitorService: getLastTransactions: status: ', status);
    console.log('MonitorService: getLastTransactions: accountingNature: ', accountingNature);

    return this.http
      .post<ITransaction[]>(this.lastTransactionsUrl, monitorFilter)
      .pipe(map(transactionList => transactionList));
  }

  getMerchants() {
    return this.http.get<Merchant[]>(this.monitorUrl).pipe(map(merchants => merchants));
  }
}
